var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"counter"},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm._f("numeral")(_vm.count,'0.[0]a')))]),(_vm.label)?_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }